import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar"; 
import { Link } from "react-router-dom"; 
import * as apiUrl from "../../apiUrl";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function HomePressRelease() {
  const [HomePressRelease, setHomePressRelease] = useState({});

  useEffect(() => {
    const fetchPressRelease = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/press-release-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomePressRelease(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPressRelease();
  }, []);

  const images = HomePressRelease.slide_images
    ? JSON.parse(HomePressRelease.slide_images)
    : [];
  const descriptions = HomePressRelease.slide_description
    ? JSON.parse(HomePressRelease.slide_description)
    : [];
  const datesAndPlaces = HomePressRelease.slide_dateandplace
    ? JSON.parse(HomePressRelease.slide_dateandplace)
    : [];


  return (

    <div className="home-press-release-sec">
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={12}>
            <div className="heading-div">
              <h2 className="common-head darkGrey" data-aos="fade-up">
                {HomePressRelease.section_title}
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container
        fluid
        className="press-release-container-div"
        data-aos="fade-up"
      >
        <Row>
          <Col md={12}>
            {images.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                navigation={true}
                spaceBetween={140}
                slidesPerView={3}
                speed={1000}
                grabCursor={true}
                draggable={true}
                initialSlide={0}
                centeredSlides={true}
                loop={true}
                breakpoints={{
                  200: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 100,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 100,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 100,
                  },
                  1280: {
                    slidesPerView: 3,
                    spaceBetween: 120,
                  },
                  1920: {
                    slidesPerView: 3,
                    spaceBetween: 240,
                  },
                  3840: {
                    slidesPerView: 3,
                    spaceBetween: 240,
                  },
                }}
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <div className="pressrelease-div">
                      <Row className="pressrelease-row">
                        <Col md={12} className="pressrelease-bg-img">
                          <div className="pressrelease-img">
                            <div className="img-holder">
                              <img
                                className="img-fluid"
                                src={`${apiUrl.apiUrl}/${image}`}
                                alt={`Real Estate development companies in Dubai`}
                              />
                            </div>
                            <div className="pressrelease-content">
                              <p className="common-para">
                                {descriptions[index]}
                              </p>
                              <h5 className="common-para">
                                {datesAndPlaces[index]}
                              </h5>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <p>Loading slides...</p>
            )}
          </Col>
        </Row>
        <div className="text-center button-section" data-aos="fade-up">
          <Row>
            <Col md={12}>
              <Link
                to={HomePressRelease.button_link}
                className="marquis-grey-button"
              >
                {HomePressRelease.button_text}
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </div>

  );
}

export default HomePressRelease;
